import { GLOBALS } from "./globals";
import { createHeadingVariantComponents } from "./setup-factories";

export const { HeadingSection } = createHeadingVariantComponents({
  Section: {
    font: {
      family: GLOBALS.font.roboto.family,
      size: "19px",
      weight: 700,
      lineHeight: "100%",
      color: GLOBALS.color.onLight[500],
    },
  },
});
